import { render, staticRenderFns } from "./Strap.vue?vue&type=template&id=182dba95&"
import script from "./Strap.vue?vue&type=script&lang=js&"
export * from "./Strap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Strap.vue"
export default component.exports